var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTasksIcon = function SvgTasksIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Task list"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.625 3C14.3355 3 9.6645 3 9.375 3C8.754 3 8.25 3.504 8.25 4.125C8.25 4.746 8.754 5.25 9.375 5.25C9.6645 5.25 14.3355 5.25 14.625 5.25C15.246 5.25 15.75 4.746 15.75 4.125C15.75 3.504 15.246 3 14.625 3Z",
    fill: "#707577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.625 8.25C14.3355 8.25 9.6645 8.25 9.375 8.25C8.754 8.25 8.25 8.754 8.25 9.375C8.25 9.996 8.754 10.5 9.375 10.5C9.6645 10.5 14.3355 10.5 14.625 10.5C15.246 10.5 15.75 9.996 15.75 9.375C15.75 8.754 15.246 8.25 14.625 8.25Z",
    fill: "#707577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.625 13.5C14.3355 13.5 9.6645 13.5 9.375 13.5C8.754 13.5 8.25 14.004 8.25 14.625C8.25 15.246 8.754 15.75 9.375 15.75C9.6645 15.75 14.3355 15.75 14.625 15.75C15.246 15.75 15.75 15.246 15.75 14.625C15.75 14.004 15.246 13.5 14.625 13.5Z",
    fill: "#707577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.5 11.25H3.75C2.92125 11.25 2.25 10.5788 2.25 9.75V9C2.25 8.17125 2.92125 7.5 3.75 7.5H4.5C5.32875 7.5 6 8.17125 6 9V9.75C6 10.5788 5.32875 11.25 4.5 11.25Z",
    fill: "#707577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M4.5 6H3.75C2.92125 6 2.25 5.32875 2.25 4.5V3.75C2.25 2.92125 2.92125 2.25 3.75 2.25H4.5C5.32875 2.25 6 2.92125 6 3.75V4.5C6 5.32875 5.32875 6 4.5 6Z",
    fill: "#707577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M4.5 16.5H3.75C2.92125 16.5 2.25 15.8288 2.25 15V14.25C2.25 13.4212 2.92125 12.75 3.75 12.75H4.5C5.32875 12.75 6 13.4212 6 14.25V15C6 15.8288 5.32875 16.5 4.5 16.5Z",
    fill: "#707577"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTasksIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "tasks-icon.917d44e43a7119bb6d25b6d4f7ca7192.svg";